import React, {useCallback, useState} from 'react';
import { Dialog, DialogContent, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoginForm from "../LoginForm/LoginForm";

const LoginDialog = ({ open: openProp, onClose, onLoginSuccess }) => {
   const [openInternal, setOpenInternal] = useState(false);
   const isControlled = openProp !== undefined;
   const open = isControlled ? openProp : openInternal;
   
   const handleOpen = () => {
      if (!isControlled) {
         setOpenInternal(true);
      }
   };
   
   const handleClose = useCallback(() => {
      if (onClose) {
         onClose();
      } else if (!isControlled) {
         setOpenInternal(false);
      } else {
         setOpenInternal(false);
      }
   },[isControlled, onClose]);
   const sharedHandle = useCallback(() => {
      console.log('sharedHandle')
      onClose();
      onLoginSuccess()
   },[onLoginSuccess, handleClose]);
   
   return (
      <>
         {!isControlled && (
            <Button variant="contained" onClick={handleOpen}>
               Open Login Dialog
            </Button>
         )}
         <Dialog open={open} onClose={handleClose}>
            <IconButton onClick={handleClose} style={{ position: 'absolute', right: 10, top: 10 }}>
               <CloseIcon />
            </IconButton>
            <DialogContent>
               <LoginForm onLoginSuccess={sharedHandle} />
            </DialogContent>
         </Dialog>
      </>
   );
};

export default LoginDialog;
